import { Link } from 'react-router-dom';

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: 'var(--bg-color)', color: 'var(--text-color)' }}>
      <div className="text-center max-w-md">
        <h1 style={{ fontFamily: 'var(--headline-font)', fontStyle: 'italic', fontSize: 'clamp(1.8rem, 4vw, 3rem)', textTransform: 'uppercase', marginBottom: '1rem' }}>Checkout Cancelled</h1>
        <p style={{ fontFamily: 'var(--body-font)', fontSize: '0.9rem', color: 'var(--muted-color)', lineHeight: 1.7, marginBottom: '2rem' }}>
          No worries — your cart is still waiting. Come back whenever you're ready.
        </p>
        <Link to="/" style={{ fontFamily: 'var(--body-font)', fontSize: '0.7rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--accent-color)', textDecoration: 'none' }}>Back to the Issue</Link>
      </div>
    </div>
  );
}
